import "./App.css";
import Header from "./components/header/header";
import Hero from "./components/hero/Hero";
import Slider from "./components/slider/Slider";
import Virtual from "./components/virtual/Virtual";
import Product from "./components/products/Product"

function App() {
  return (
    <div className="App">  
      <Header/> 
      <Hero/>
      <Slider/>
      <Virtual/>
      <Product/>
    </div>
  );
}

export default App;
